<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="accent white--text title">
                    Condenser Health
                </v-card-title>
                <v-card-text>
                    <v-layout>
                        <v-flex xs12>
                            <date-range-selector v-model="range"></date-range-selector>
                            <equipment-selector v-model="equip"></equipment-selector>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text>
                    <v-layout>
                        <v-flex xs12>
                            <scatter-plot variable-x="Cond_Approach"
                                          variable-y="Cond_Approach"
                                          :facility_name="facility_name"
                                          :equipment_name="equip"
                                          :on-only="true"
                                          :date-range="range"
                                          type="dygraph"
                            ></scatter-plot>

                            <scatter-plot variable-x="SW_Temp_Diff"
                                          variable-y="SW_Temp_Diff"
                                          :facility_name="facility_name"
                                          :equipment_name="equip"
                                          :on-only="true"
                                          :date-range="range"
                                          type="dygraph"
                            ></scatter-plot>

                            <scatter-plot variable-x="SWS_Temp"
                                          variable-y="SWR_Temp"
                                          :facility_name="facility_name"
                                          :equipment_name="equip"
                                          :on-only="true"
                                          :date-range="range"
                                          type="dygraph"
                            ></scatter-plot>

                            <scatter-plot variable-x="Cond_Sat_Refrig_Temp"
                                          variable-y="Cond_Sat_Refrig_Temp"
                                          :facility_name="facility_name"
                                          :equipment_name="equip"
                                          :on-only="true"
                                          :date-range="range"
                                          type="dygraph"
                            ></scatter-plot>

                            <scatter-plot variable-x="Cond_Sat_Refrig_Press"
                                          variable-y="Cond_Sat_Refrig_Press"
                                          :facility_name="facility_name"
                                          :equipment_name="equip"
                                          :on-only="true"
                                          :date-range="range"
                                          type="dygraph"
                            ></scatter-plot>

                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import DateRangeSelector from '../../components/DateRangeSelector'
    import EquipmentSelector from '../../components/EquipmentSelector'
    import ScatterPlot from '../../components/ScatterPlot'

    export default {
        name: 'CondenserHealth',
        components: {ScatterPlot, EquipmentSelector, DateRangeSelector},
        data() {
            return {
                equip: null,
                range: null
            }
        },
        computed: {
            facility_name() {
                return this.$store.state.pointsListStore.facility_name
            }
        }
    }
</script>